import { HASH_MODAL } from './default/const.js';

export default [
  {
    text: 'Задать вопрос',
    to: { hash: HASH_MODAL },
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.ask-pfdod.js